import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWarningIconTrace = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16.9449 0.609101C16.5183 -0.10668 15.4817 -0.10668 15.0551 0.609102L0.217818 25.5038C-0.219185 26.237 0.309148 27.167 1.16272 27.167H30.8372C31.6908 27.167 32.2192 26.237 31.7822 25.5038L16.9449 0.609101ZM15.9141 1.12107C15.9528 1.056 16.0471 1.056 16.0859 1.12107L30.9231 26.0158C30.9629 26.0824 30.9148 26.167 30.8372 26.167H1.16272C1.08513 26.167 1.0371 26.0824 1.07682 26.0158L15.9141 1.12107ZM14.564 9.57074C14.5327 8.75604 15.1847 8.07851 16 8.07851C16.8153 8.07851 17.4672 8.75605 17.4359 9.57074L17.1076 18.106C17.0847 18.7012 16.5956 19.1719 16 19.1719C15.4043 19.1719 14.9152 18.7012 14.8923 18.106L14.564 9.57074ZM17.5997 22.3491C17.5997 23.2328 16.8834 23.9491 15.9997 23.9491C15.1161 23.9491 14.3997 23.2328 14.3997 22.3491C14.3997 21.4655 15.1161 20.7491 15.9997 20.7491C16.8834 20.7491 17.5997 21.4655 17.5997 22.3491Z",
		fill: "currentColor"
	})
});
export default SvgWarningIconTrace;
